import { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const shimmerStyle = {
  background: 'linear-gradient(90deg, #f0f2f7 25%, #e2e6ef 50%, #f0f2f7 75%)',
  backgroundSize: '200% 100%',
  animation: 'shimmer 1.4s infinite',
  borderRadius: '4px',
};

const VerticalBarChart = ({ data, xAxisLabel, loading = false, grouped = false, stacked = false, yAxisPrefix = '', yAxisSuffix = 'volumes' }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (loading || !data || !canvasRef.current) return;

    const existing = Chart.getChart(canvasRef.current);
    if (existing) existing.destroy();

    const chart = new Chart(canvasRef.current, {
      type: 'bar',
      data: data,
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: { display: grouped || stacked, position: 'bottom', labels: { font: { size: 11 }, boxWidth: 10, padding: 10 } },
          tooltip: {
            callbacks: { label: (c) => grouped || stacked ? `${c.dataset.label}: ${yAxisPrefix}${c.parsed.y}` : `${c.parsed.y}${yAxisSuffix ? ' ' + yAxisSuffix : ''}` },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            stacked: stacked,
            ticks: { 
              font: { size: 10 },
              callback: (v) => yAxisPrefix + v,
            },
            grid: { color: '#eef1f7' },
          },
          x: {
            stacked: stacked,
            ticks: { font: { size: 10 } },
            grid: { display: false },
            title: {
              display: !!xAxisLabel,
              text: xAxisLabel || '',
              font: { size: 10 },
              color: '#9aa3b7',
            },
          },
        },
      },
    });

    return () => chart.destroy();
  }, [data, xAxisLabel, loading, grouped, stacked, yAxisPrefix]);

  if (loading) {
    return (
      <div className="chart-wrap" style={{ display: 'flex', alignItems: 'flex-end', gap: '8px', padding: '10px 0' }}>
        {[50, 80, 65, 90, 40, 60].map((h, i) => (
          <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
            <div style={{ ...shimmerStyle, width: '100%', height: `${h}%` }} />
            <div style={{ ...shimmerStyle, width: '80%', height: '8px' }} />
          </div>
        ))}
      </div>
    );
  }

  if (!data) {
    return (
      <div className="chart-wrap" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--muted)', fontSize: '12px' }}>
        No data available
      </div>
    );
  }

  return (
    <div className="chart-wrap">
      <canvas ref={canvasRef}></canvas>
    </div>
  );
};

export default VerticalBarChart;